module.exports = __webpack_public_path__ + "img/pr-16.258861d8.png";